module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS3.389f02a2.jpg";